import { createContext } from 'react';

const AppDataContext = createContext();

export default AppDataContext;
